<template>
  <div class="container-fluid mt-5" style="max-width: 800px; margin-bottom: 140px;">

    <div class="row m-3" v-if="erro">
      <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
        {{ erro }}
      </div>
    </div>

    <div class="row">
      <div class="col mx-1 my-3 login-acesso" v-if="(MODULOS.MARKETPLACE || !MODULOS.MARKETPLACE) && !MODULOS.SPORTHECA">
        <h5 class="cor-texto"><strong> Já sou cliente</strong></h5>
        <form class="my-1 px-5 py-3 shadow form" @submit.prevent="singIn">
          <div class="mb-3" v-if="MODULOS.MARKETPLACE">
            <label for="user" class="form-label">CPF ou CNPJ</label>
            <input class="form-control" type="text" id="user" placeholder="000.000.000-00" v-model="login.user"
              v-mask="['###.###.###-##', '##.###.###/####-##']" required />
          </div>
          <div class="mb-3" v-else>
            <label for="user" class="form-label">CPF</label>
            <input class="form-control" type="text" id="user" placeholder="000.000.000-00" v-model="login.user"
              v-mask="['###.###.###-##']" required />
          </div>
          <div class="mb-3">
            <label for="password" class="form-label">Senha</label>
            <input class="form-control" type="password" id="password" placeholder="* * * * *" v-model="login.password"
              required />
          </div>
          <button class="btn col" type="submit">Continuar</button>
        </form>
        <div class="my-3" v-if="!MODULOS.SPORTHECA">
          <router-link :to="`/esqueceu-senha`" tag="a">
            <span>Esqueceu a senha?</span>
          </router-link>
        </div>
      </div>
      <div class="col mx-1 my-3 login-acesso" v-else>
        <h5 class="cor-texto"><strong> Já sou cliente</strong></h5>
        <form class="my-1 px-5 py-3 shadow form" @submit.prevent="singInSportheca">
          <div class="mb-3">
            <label for="user" class="form-label">Email</label>
            <input class="form-control" type="text" id="email" placeholder="seu@email.com" v-model="login.email"
              required />
          </div>
          <div class="mb-3">
            <label for="hashSenha" class="form-label">Senha</label>
            <input class="form-control" type="password" id="hashSenha" placeholder="* * * * *" v-model="login.hashSenha"
              required />
          </div>
          <button class="btn col" type="submit">Continuar</button>
        </form>
        <div class="my-3">
          <router-link :to="`/esqueceu-senha`" tag="a">
            <span>Esqueceu a senha?</span>
          </router-link>
        </div>
      </div>
      <div v-if="showCardNovaConta" class="v-line"></div>
      
      <div class="col mx-1 my-3 login-conta" v-if="showCardNovaConta">
        <div v-if="(MODULOS.MARKETPLACE || !MODULOS.MARKETPLACE) && !MODULOS.SPORTHECA">
          <h5 class="cor-texto"><strong> Quero criar uma conta</strong></h5>
          <form class="my-1 px-5 py-3 shadow form" @submit.prevent="criarConta">
            <div class="mb-3" v-if="MODULOS.MARKETPLACE">
              <label for="user" class="form-label">CPF ou CNPJ</label>
              <input class="form-control" type="text" id="user" placeholder="000.000.000-00" v-model="contaNova.cpfCnpj"
                v-mask="['###.###.###-##', '##.###.###/####-##']" required />
            </div>
            <div class="mb-3" v-else>
              <label for="user" class="form-label">CPF</label>
              <input class="form-control" type="text" id="user" placeholder="000.000.000-00" v-model="contaNova.cpfCnpj"
                v-mask="['###.###.###-##']" required />
            </div>
            <button class="btn col" type="submit">Continuar</button>
          </form>
          <div class="my-3">
            <small>
              <p>
                Seus dados pessoais serão respeitados de acordo com a nossa
                <router-link :to="`/pagina/politica-de-privacidade`" tag="a">
                  <span>política de privacidade.</span>
                </router-link>
  
              </p>
            </small>
          </div>
        </div>
        <div class="col mx-1 my-3 login-conta" v-else>
          <h5 class="cor-texto"><strong> Quero criar uma conta</strong></h5>
          <form class="my-1 px-5 py-3 shadow form" @submit.prevent="criarContaSportheca">
            <div class="mb-3">
              <label for="user" class="form-label">Não tem uma conta?</label>
            </div>
            <button class="btn col" type="submit">Cadastre-se</button>
          </form>
          <div class="my-3">
            <small>
              <p>
                Seus dados pessoais serão respeitados de acordo com a nossa
                <router-link :to="`/pagina/politica-de-privacidade`" tag="a">
                  <span>política de privacidade.</span>
                </router-link>
  
              </p>
            </small>
          </div>
        </div>
      </div>

      <div  v-if="infoDuvidas" class="container text-center mt-1">
        <div v-if="infoDuvidas" v-html="infoDuvidas"></div>
      </div>

      </div>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import { APIService } from "../APIService";
const apiService = new APIService();
import { sha256 } from "../shared/helpers/helpers";

export default {
  name: "Login",
  components: { Loading },
  data() {
    return {
      MODULOS: window.MODULOS,
      showCardNovaConta: 'SHOW_CRIAR_CONTA' in window.MODULOS ?  window.MODULOS.SHOW_CRIAR_CONTA: true,
      login: {
        user: "",
        hashSenha: ""
      },
      erro: "",
      contaNova: {
        cpfCnpj: "",
        email: ""
      },
      loading: false,
      infoDuvidas: null,
    };
  },
  created() {
    this.$route.query.accessToken && this.$router.push(`/`);
    window.scrollTo(0, 0);
    this.$store.dispatch("toogleMicroApp", +this.$route.query.toogleMicroApp);
  },
  mounted() { 
    this.obterFuncionalidades();
  },
  methods: {
    criarConta() {
      this.loading = true;
      this.erro = "";
      let cpfCnpj = this.contaNova.cpfCnpj;
      apiService
        .verificarContaExistente(cpfCnpj)
        .then(response => {
          if (response.sucesso) {
            this.$router.push({
              path: `/cadastrar`,
              query: { cpfCnpj: cpfCnpj, nextUrl: this.$route.query.nextUrl }
            })
            this.loading = false;
          }
        })
        .catch(error => {
          if (error) {
            this.erro = error.response.data.title;
          }
          this.loading = false;
          window.scrollTo(0, 0);
        });
    },
    criarContaSportheca() {
      this.loading = true;
      this.$router.push({
        path: `/cadastrarSportheca`
      });
      this.loading = false;

    },
    validarCpfCnpj(CpfCnpj) {
      return apiService.validaCpfCnpj(CpfCnpj);
    },
    async singIn() {
      this.loading = true;
      if (apiService.validaCpfCnpj(this.login.user)) {
        const { user, password } = this.login;
        await apiService
          .login({
            usuario: this.removeMask(user),
            hashSenha: sha256(password)
          })
          .then(response => {
            this.$store.dispatch("loginApp", response);
            this.getPedidoPendente();
            if (this.$route.query.nextUrl != null) {
              this.$router.push(this.$route.query.nextUrl);
            } else {
              this.$router.push(
                `${this.MODULOS.LANDING ? "/loja" : this.MODULOS.CLUBE_DESCONTO === true || this.MODULOS.VANTAGO_CLUB === true ? "/servico/clube-desconto" : ""
                }/${window.location.hash.split("?")[1] || ""}`
              );
            }
            this.loading = false;
          })
          .catch(error => {
            if (error) {
              this.erro = error.response.data.title;
              window.scrollTo(0, 0);

              if (error.response.data.title === "Usuário não ativado") {
                this.$router.push({
                  path: `/validar-codigo`,
                  query: { cpfCnpj: user, nextUrl: this.$route.query.nextUrl }
                })
              }
            }
            this.loading = false;
          });
      } else {
        this.loading = false;

        this.erro = 'CPF ou CNPJ inválido!';
      }
    },
    async singInSportheca() {
      this.loading = true;
      const { email, hashSenha } = this.login;
      await apiService
        .loginSportheca({
          usuario: email,
          hashSenha: hashSenha
        })
        .then(response => {
          this.$store.dispatch("loginApp", response);
          this.getPedidoPendente();
          if (this.$route.query.nextUrl != null) {
            this.$router.push(this.$route.query.nextUrl);
          } else {
            this.$router.push(
              `${this.MODULOS.LANDING ? "/loja" : ""
              }/${window.location.hash.split("?")[1] || ""}`
            );
          }
          this.loading = false;
        })
        .catch(error => {
          if (error) {
            this.erro = error.response.data.title;
            window.scrollTo(0, 0);
          }
          this.loading = false;
        });
    },
    removeMask(n) {
      return n.replace(/\D/gm, "");
    },
    getPedidoPendente() {
      apiService.getPedidoPendente().then((response) => {
        this.setPedidoToLocalStorage(response)
      });
    },
    setPedidoToLocalStorage(pedido) {
      this.$store.state.pedido.itens = [];
      this.$store.state.pedido.valorTotal = 0;
      this.$store.state.pedido.valorFrete = 0;
      this.$store.state.pedido.valorCompra = 0;
      this.$store.state.pedido.valorDesconto = 0;
      this.$store.state.pedido.id = null;

      if (pedido.status === 'AGUARDANDO_CHECKOUT') {
        this.$store.state.pedido.itens = !pedido.itens ? [] : pedido.itens;
        this.$store.state.pedido.valorTotal = pedido.valorTotal;
        this.$store.state.pedido.valorFrete = pedido.valorFrete;
        this.$store.state.pedido.valorCompra = pedido.valorCompra;
        this.$store.state.pedido.valorCompra = pedido.valorDesconto;
        this.$store.state.pedido.id = pedido.id;
      }

      setTimeout(() => {
        localStorage.setItem("carrinho", JSON.stringify(this.$store.state.pedido));
      }, 500);
    },
    obterFuncionalidades() {
      this.loading = true;
      apiService
        .getFuncionalidadeV2(window.APP_ORIGIN)
        .then(res => {
          const funcionalidades = res.filter(e => {
            return "MICROAPP_TEXTOS" == e.funcionalidade;
          });

          if (funcionalidades[0]) {
            const valorString = funcionalidades[0].valorString;
            this.funcionalidades = JSON.parse(valorString);

            const infoDuvidas = this.funcionalidades.find(objeto => objeto.codigoMicroapp === "MAPP_FOOTER");
            if (infoDuvidas && infoDuvidas.ativo) {
              const currentRoute = this.$route.path;
              let rotaCorresponde = false;
              for (const pagina of infoDuvidas.paginas) {
                if (currentRoute.includes(pagina)) {
                  rotaCorresponde = true;
                  break;
                }
              }

              if (rotaCorresponde) {
                this.infoDuvidas = infoDuvidas.html;
              }
            }
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log("log error", error);
          this.loading = false;
        });
    },
  }
};
</script>
<style scoped lang="scss">
button {
  background: var(--cor-principal);
  color: var(--cor-texto);
}

.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: "";
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid #e7e7e7;
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }

  h5 {
    line-height: 1;
    font-size: 12px;
    color: #767676;
    font-weight: 400;
    z-index: 2;
    position: relative;
    display: inline-block;
    background-color: #fff;
    padding: 0 8px 0 7px;
  }
}

.login-acesso {
  align-items: flex-start;
  min-width: 300px;
}

.login-conta {
  align-items: flex-end;
  min-width: 300px;
}

@media (min-width: 638px) {
  .v-line {
    border-left: 2px solid var(--cor-secundaria);
    height: 220px;
    margin-top: 55px;
    margin-left: 20px;
    margin-right: 20px;
  }

}

.loader-content {
  margin: auto;
  height: 500px;
  width: 300px;
  align-content: center;
  display: flex;
  align-items: center;
}

.form {
  min-height: 250px;
}

.loader {
  align-content: center;
  border: 16px solid #f3f3f3;
  border-top: 16px solid var(--cor-principal);
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
}

.cor-texto {
  color: var(--cor-secundaria);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
